<template>
  <summary-details />
</template>
<script>
import SummaryDetails from './components/SummaryDetails';
export default {
  components: {
    SummaryDetails
  }
}
</script>